export default __webpack_public_path__ + "static/media/profilePageIcon.8e37f1a6.svg";